class LoansRepaymentLoanInfoController {
  constructor() {
  }
}

export default LoansRepaymentLoanInfoController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansRepayment/loansRepaymentLoanInfo/loansRepaymentLoanInfo.controller.js